import React from "react";
import { CheckIcon, MinusIcon } from "lucide-react";
import { planTableRows, plans } from "../../data/plans";
function Mark({
  on
}: {
  on: boolean;
}) {
  return on ? <>
      <CheckIcon className="mx-auto h-5 w-5 text-salvia-deep" strokeWidth={3} aria-hidden="true" data-id="element-215" data-mp="2xybv2w01ktoz" />
      <span className="sr-only" data-id="element-216" data-mp="32xf0winuj3y0">Incluido</span>
    </> : <>
      <MinusIcon className="mx-auto h-4 w-4 text-pizarra/35" aria-hidden="true" data-id="element-217" data-mp="32wn9zl571ue2" />
      <span className="sr-only" data-id="element-218" data-mp="25b7nqkdh83a1">No incluido</span>
    </>;
}
export function PlanTable() {
  return <section id="tabla" aria-labelledby="tabla-title" className="scroll-mt-20 py-20 md:py-28" data-id="element-219" data-mp="2a99frusvrcxn">
      <div className="mx-auto max-w-4xl px-4 md:px-6" data-id="element-220" data-mp="2f69d9hbnz7d5">
        <h2 id="tabla-title" className="text-center font-serif text-3xl font-medium text-pizarra-deep md:text-4xl" data-id="element-221" data-mp="2k7gk9e5zg2ir">
          Qué incluye cada plan
        </h2>
        <div className="mt-10 overflow-x-auto" data-id="element-222" data-mp="3qp3q3q5dfcaq">
          <table className="w-full min-w-[480px] border-collapse text-left" data-id="element-223" data-mp="3vlaydpl8ozvu">
            <caption className="sr-only" data-id="element-224" data-mp="34tsxcybt4lwf">Comparación de contenidos de los planes Base, Pro y Completo</caption>
            <thead data-id="element-225" data-mp="2zugcgj4hxowh">
              <tr data-id="element-226" data-mp="2zw186c2jrdvx">
                <th scope="col" className="w-[40%] py-4 pr-3 text-sm font-semibold text-pizarra-soft" data-id="element-227" data-mp="2zvhmck9s05cm">
                  Contenido
                </th>
                {plans.map(p => <th key={p.id} scope="col" className={`px-3 py-4 text-center font-serif text-xl font-medium ${p.id === "completo" ? "rounded-t-2xl bg-sakura-light text-terracota-deep" : "text-pizarra-deep"}`} data-id="element-228" data-mp="2qti5bryrh19o">
                    {p.name}
                  </th>)}
              </tr>
            </thead>
            <tbody data-id="element-229" data-mp="234phkisalzq5">
              {planTableRows.map(r => <tr key={r.label} className="border-t border-pizarra/10" data-id="element-230" data-mp="23460t5edphdp">
                  <th scope="row" className="py-4 pr-3 font-medium text-pizarra-deep" data-id="element-231" data-mp="1y6nm0ydok7xs">
                    {r.label}
                  </th>
                  <td className="px-3 py-4 text-center" data-id="element-232" data-mp="1ok37ayrddbnf"><Mark on={r.base} data-id="element-233" data-mp="1thmkdvcbzids" /></td>
                  <td className="px-3 py-4 text-center" data-id="element-234" data-mp="1tio74x2pltbc"><Mark on={r.pro} data-id="element-235" data-mp="1eju7zc22za3t" /></td>
                  <td className="bg-sakura-light px-3 py-4 text-center" data-id="element-236" data-mp="1ekvuccojrj0u"><Mark on={r.completo} data-id="element-237" data-mp="1jixdexlz3icb" /></td>
                </tr>)}
              <tr className="border-t-2 border-pizarra/20" data-id="element-238" data-mp="1jl02nffax7fz">
                <th scope="row" className="py-4 pr-3 font-semibold text-pizarra-deep" data-id="element-239" data-mp="279ja5sqj1g70">
                  Total de ebooks
                </th>
                {plans.map(p => <td key={p.id} className={`px-3 py-4 text-center font-serif text-2xl ${p.id === "completo" ? "rounded-b-2xl bg-sakura-light text-terracota-deep" : "text-pizarra-deep"}`} data-id="element-240" data-mp="1xj86m7ar990n">
                    {p.ebooks}
                  </td>)}
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mx-auto mt-8 max-w-2xl text-center leading-relaxed text-pizarra" data-id="element-241" data-mp="jhsh97jgcgg5">
          Elegí Base para trabajar con los siete tomos. Pro suma práctica de kanji. Completo agrega herramientas para
          viajes y consulta de vocabulario.
        </p>
      </div>
    </section>;
}